import { motion } from 'motion/react'
import { Colors } from '@kvika/audur-theme'

export const Path = (props: any) => (
	<motion.path
		fill={Colors.Silver}
		strokeWidth='3'
		strokeOpacity={1}
		stroke={Colors.Silver}
		strokeLinecap='round'
		{...props}
	/>
)
